import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate } from 'react-router-dom';
import './TIJSidebar.css';



import BarcodePrinters from './BarcodePrinters';
import BarcodeScanners from './BarcodeScanners';

const BarcodeLayout = ({ mode }) => {
  // Use URL parameter or default to the provided mode or 'type1'
  const { type } = useParams();
  const navigate = useNavigate();
  const [activeComponent, setActiveComponent] = useState(type || mode || 'type1');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Update URL when activeComponent changes
  useEffect(() => {
    navigate(`/barcode-products/${activeComponent}`);
  }, [activeComponent, navigate]);

  // Handle component switching
  const handleComponentChange = (component) => {
    setActiveComponent(component);
    setIsSidebarOpen(false);
  };

  // Render the active component

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'type1':
        return <BarcodePrinters/>;
      case 'type2':
        return <BarcodeScanners/>;
      default:
        return <BarcodePrinters/>;
    }
  };

  return (
    <div className="page-container">
      <div className="content-wrap">
      
        {/* Mobile Navigation (Horizontal) */}
        <div className="mobile-nav">
          <button
            className={`nav-link ${activeComponent === 'type1' ? 'active' : ''}`}
            onClick={() => handleComponentChange('type1')}
          >
            Barcode Printers
          </button>
          <button
            className={`nav-link ${activeComponent === 'type2' ? 'active' : ''}`}
            onClick={() => handleComponentChange('type2')}
          >
            Barcode Scanners        
          </button>
          
        </div>

        {/* Hamburger Menu Toggle Button (Visible on Small Screens) */}
        <button
          className="sidebar-toggle"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          ☰
        </button>

        {/* Sidebar */}
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="mb-3 ml-3 mt-3" style={{fontSize:"19px", fontWeight:"bold", textDecoration:"underline"}}>Barcode Categories</div>
          <nav className="nav flex-column">
            <button
              className={`nav-link ${activeComponent === 'type1' ? 'active' : ''}`}
              onClick={() => handleComponentChange('type1')}
            >
               Barcode Printers
            </button>
            <button
              className={`nav-link ${activeComponent === 'type2' ? 'active' : ''}`}
              onClick={() => handleComponentChange('type2')}
            >
             Barcode Scanners
            </button>
            
          </nav>
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
};

export default BarcodeLayout;